export default () => ({
  includes: ['covenant', 'dependent', 'plan'],
  covenant: {
    id: null,
    user_id: null,
    dependent_id: null,
    covenant_id: null,
    plan_id: null,
    card_number: null,
    active: true,
    covenant: {}
  },
  covenants: [],
  entity: 'covenant',
  entities: 'covenants',
  prefixRouter: 'settings.covenants'
})



// WEBPACK FOOTER //
// ./src/app/settings/covenants/resources/data.js